// Language-aware dates. Month/weekday names come from the date-fns locale of the active
// language (registry in ui-seeker `getDateFnsLocale`), so a new language needs no code here.
import i18n from 'i18n'
import { DEFAULT_LANGUAGE, normalizeLanguage } from 'i18n/config'
import { formatDate, getDateFnsLocale } from 'ui-seeker/utils'

const MONTHS = [...Array(12).keys()]
// date-fns day indexes (0 = Sunday), Monday-first
const WEEKDAYS_MONDAY_FIRST = [1, 2, 3, 4, 5, 6, 0]

// style → date-fns localize width
const WIDTHS = { long: 'wide', short: 'abbreviated', narrow: 'short' }

const capitalizeFirst = text => text ? text.charAt(0).toUpperCase() + text.slice(1) : text

export const activeLanguage = () => normalizeLanguage(i18n.language) || DEFAULT_LANGUAGE

export const activeDateFnsLocale = () => getDateFnsLocale(activeLanguage())

// Same signature as ui-seeker `formatDate` (date, {format, isString, receivedFormat}) but with the
// active language locale: `MMM` / `MMMM` / `EEE` render in the user's language.
export const formatDateI18n = (date, options = {}) =>
    formatDate(date, { ...options, locale: activeDateFnsLocale() })

// ['January', ...] (long) | ['Jan', ...] (short) in the active language, capitalized.
export const monthNames = (style = 'long') => {
    const { localize } = activeDateFnsLocale()
    return MONTHS.map(month => capitalizeFirst(localize.month(month, { width: WIDTHS[style] })))
}

// Monday-first ['Monday', ...] (long) | ['Mon', ...] (short) | ['Mo', ...] (narrow), capitalized.
export const weekdayNames = (style = 'long') => {
    const { localize } = activeDateFnsLocale()
    return WEEKDAYS_MONDAY_FIRST.map(day => capitalizeFirst(localize.day(day, { width: WIDTHS[style] })))
}
